export default "__VITE_ASSET__Cd1vxx$j__"